import { useTranslation } from 'react-i18next';
import styles from './Footer.module.scss';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <span className={styles.copy}>{t('footer.copy')}</span>
        <span className={styles.tagline}>{t('footer.tagline')}</span>
      </div>
    </footer>
  );
};

export default Footer;
